/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Users_Form_Search_BranchesInputs */

const en_users_form_search_branches = /** @type {(inputs: Users_Form_Search_BranchesInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Search branches by name…`)
};

const pt_br2_users_form_search_branches = /** @type {(inputs: Users_Form_Search_BranchesInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Buscar filiais por nome…`)
};

/**
* | output |
* | --- |
* | "Search branches by name…" |
*
* @param {Users_Form_Search_BranchesInputs} inputs
* @param {{ locale?: "en" | "pt-BR" }} options
* @returns {LocalizedString}
*/
export const users_form_search_branches = /** @type {((inputs?: Users_Form_Search_BranchesInputs, options?: { locale?: "en" | "pt-BR" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Users_Form_Search_BranchesInputs, { locale?: "en" | "pt-BR" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_users_form_search_branches(inputs)
	return pt_br2_users_form_search_branches(inputs)
});